module.exports = {"en-US":{"components":{"paginator":{"first":"Start","prev":"","next":"","last":"End"}}}}